export const _TRANSLATIONS = {
    TR: {
        search: 'Ara',
        select_language: 'Dil Seçiniz',
        restaurants: 'Restoranlar',
        map: 'Harita',
        information: 'Bilgi',
        powered: '® DigyGlobal',
        services: 'Hizmetler',
        room_service: 'Oda Servisi',
        room_information: 'Oda Bilgilendirme'
    },
    EN: {
        search: 'Search',
        select_language: 'Select Language',
        restaurants: 'Restaurants',
        map: 'Map',
        information: 'Information',
        powered: '® DigyGlobal',
        services: 'Services',
        room_service: 'Room Service',
        room_information: 'Room Information'
    },
    DE: {
        search: 'Suche',
        select_language: 'Sprache auswählen',
        restaurants: 'Restaurants',
        map: 'Karte',
        information: 'Information',
        powered: '® DigyGlobal',
        services: 'Dienstleistungen',
        room_service: 'Zimmerservice',
        room_information: 'Zimmerinformationen'
    },
    RU: {
        search: 'Поиск',
        select_language: 'Выбрать язык',
        restaurants: 'Рестораны',
        map: 'карта',
        information: 'Информация',
        powered: '® DigyGlobal',
        services: 'Услуги',
        room_service: 'Обслуживание номеров',
        room_information: 'Информация о номере'
    }
}
